import { fbt } from 'fbtee'
import { Sparkles } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

interface Props {
  variant: 'guest' | 'user'
  onCta: () => void
}

export function WelcomeHeroCard({ variant, onCta }: Props) {
  const isGuest = variant === 'guest'

  const headline = isGuest
    ? fbt(
        'Plan your festival season.',
        'Welcome hero card headline for guest users on the home page',
      )
    : fbt(
        'Your schedule starts here.',
        'Welcome hero card headline for signed-in users with no events on the home page',
      )

  const description = isGuest
    ? fbt(
        'Discover what your friends are going to, compare lineups, and coordinate who catches which set.',
        'Welcome hero card description for guests mentioning the friends and lineup features',
      )
    : fbt(
        'Mark Going on any event and it will appear here. Add friends to see who is joining you.',
        'Welcome hero card description for signed-in users with no events yet',
      )

  const ctaLabel = isGuest
    ? fbt('Log in', 'Primary CTA on the welcome hero card for guests')
    : fbt('Browse events', 'CTA on the welcome hero card for signed-in users with no events')

  return (
    <Card
      style={{
        backgroundImage:
          'linear-gradient(to bottom, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.72) 100%), linear-gradient(135deg, hsl(255 65% 30%), hsl(200 55% 22%))',
      }}
      className="relative flex min-h-56 flex-col justify-between overflow-hidden p-4 border-primary/30"
    >
      <div className="flex items-center gap-2 text-on-image/80">
        <Sparkles className="size-4" />
        <span className="text-sm font-semibold tracking-wide">Faro</span>
      </div>

      <div className="space-y-4">
        <div className="space-y-1.5">
          <h2 className="text-2xl font-bold leading-tight text-on-image drop-shadow-sm">{headline}</h2>
          <p className="text-sm text-on-image/75">{description}</p>
        </div>
        <Button onClick={onCta} className="w-fit cursor-pointer">
          {ctaLabel}
        </Button>
      </div>
    </Card>
  )
}
